import { Text } from '@chakra-ui/react';
import { formatSimpleValue } from '../utils/fieldFormatting';
import DataTableCard from './DataTableCard';
import ValidationBadge from './ValidationBadge';

interface DateFirstLicensedCardProps {
  data?: any;
}

const DateFirstLicensedCard = ({ data }: DateFirstLicensedCardProps) => {
  // Get processed data
  const driverRows = data?.driverRows || [];

  const formatDate = (dateString: string) => {
    if (!dateString || dateString.trim() === '') {
      return (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          Not provided
        </Text>
      );
    }
    return formatSimpleValue(dateString);
  };

  const formatDriverName = (name: string) => {
    if (!name || name.trim() === '') {
      return (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          Not provided
        </Text>
      );
    }
    return name;
  };

  const headers = [
    'Driver',
    'Date First Licensed (App)',
    'License Issue Date (MVR)',
    'Expiry Date (MVR)',
    'Birthdate (MVR)',
    'Remarks',
    'Outcome',
  ];

  const rows = driverRows.map((row: any) => [
    formatDriverName(row.driverName),
    formatDate(row.appDateFirstLicensed),
    formatDate(row.mvrLicenseIssueDate),
    formatDate(row.mvrExpiryDate),
    formatDate(row.mvrBirthdate),
    row.remarks ? (
      <Text fontSize="sm">{formatSimpleValue(row.remarks)}</Text>
    ) : (
      <Text color="gray.400" fontStyle="italic" fontSize="sm">
        No remarks
      </Text>
    ),
    row.isValid ? (
      <ValidationBadge status="pass" />
    ) : (
      <ValidationBadge status="caution" />
    ),
  ]);

  return (
    <DataTableCard
      description="Check to ensure that the date first licensed is correct."
      headers={headers}
      rows={rows}
    />
  );
};

export default DateFirstLicensedCard;
